import { createFileRoute } from "@tanstack/react-router";
import { SweepDetail } from "../../features/runs/sweep-detail";

export const Route = createFileRoute("/_authed/$org/$project/sweeps/$name/$tab")({ component: SweepPage });

function SweepPage() {
  const { org, project, name, tab } = Route.useParams();
  return <SweepDetail scope={{ org, project }} name={name} tab={tab} />;
}
